import { Injectable } from "@angular/core";
import { GetAppVersionDAO } from "@app/core/version/data/local/get-app-version.dao";
import { VersionRepo } from "@app/core/version/domain/version.repo";
import { AppVersion } from "@app/core/version/domain/model/app-version";

import { Observable } from "rxjs";
import { GetMinimumVersionWS } from "@app/core/version/data/network/get-minimum-version.ws";

@Injectable({
  providedIn: "root",
})
export class VersionDataRepo implements VersionRepo {
  constructor(
    private getMinimumVersionWS: GetMinimumVersionWS,
    private getAppVersionDAO: GetAppVersionDAO
  ) {}

  getMinimumVersion(): Observable<AppVersion> {
    return this.getMinimumVersionWS.execute();
  }

  getAppVersion(): Observable<AppVersion> {
    return this.getAppVersionDAO.get();
  }
}
